import { useEffect, useRef } from 'react';

/**
 * While `enabled`, calls `onEscape` when the user presses Escape.
 * Uses a ref for the callback so callers don’t need `useCallback` for a stable handler.
 */
export function useEscapeKey(enabled: boolean, onEscape: () => void): void {
  const cbRef = useRef(onEscape);
  cbRef.current = onEscape;

  useEffect(() => {
    if (!enabled) return;
    const handler = (e: KeyboardEvent) => {
      if (e.key !== 'Escape') return;
      e.preventDefault();
      cbRef.current();
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [enabled]);
}
